import { isNumber } from 'lodash';
import numeral from 'numeral';

export const getCountValue = (value?: number): string => {
    let countValue;
    let format = '0,0';

    if (value && value >= 10000) {
        if (value <= 999999) {
            format += '[.][0]a';
        }
        if (value >= 1000000) {
            format += '[.][00]a';
        }
        countValue = numeral(value).format(format);
    } else {
        countValue = numeral(value).format(format);
        if (value && value < 10) {
            countValue = numeral(value).format('0[.][0]');
        }
    }
    return countValue;
};

export const getPercentValue = (value?: number, precision?: number, trimTrailingDecimalZeros = false): string => {
    let precisionValue;

    if (isNumber(precision)) {
        precisionValue = precision;
    } else if (value && Math.abs(value) > 0 && Math.abs(value) <= 0.05) {
        precisionValue = 3;
    } else {
        precisionValue = 1;
    }

    const decimalFormat =
        precisionValue === 0
            ? ''
            : `${trimTrailingDecimalZeros ? '[.][' : '.'}${'0'.repeat(precisionValue)}${
                  trimTrailingDecimalZeros ? ']' : ''
              }`;
    const format = `0,0${decimalFormat}`;
    const formattedValue = numeral(value).format(format);

    return formattedValue;
};
